import { CliUser } from "../types/users";

export function rand<K>(input: K[]) {
  return input[Math.floor(Math.random() * input.length)]
}

export function unique<K>(input: K[]) {
  return Array.from(new Set(input))
}

export function uniqueObj<K>(input: K[], key: keyof K) {
  return Array.from(new Map(input.map(i => [i[key], i])).values())
}

export function Itter<K>(length: number, gen: (i: number) => K) {
  const res = [];
  for (let i = 0; i < length; i++) {
    res.push(gen(i))
  }
  return res;
}

export function updateUser(user: CliUser, newProps: Partial<CliUser>): CliUser {
  return {...user, ...newProps}
}

export function debuglog(...params: any) {
  return// console.log(...params)
}